(function() {
    const STORAGE_KEY = "tracking_params";
    function getUrlParams() {
        const params = {};
        const usp = new URLSearchParams(window.location.search);
        usp.forEach((value, key)=>{
            params[key] = value;
        });
        return params;
    }
    function saveParams(params) {
        if (Object.keys(params).length > 0) localStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    }
    function loadParams() {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : {};
    }
    function attachParamsToCheckoutLinks() {
        const params = loadParams();
        if (!Object.keys(params).length) return;
        document.querySelectorAll("[data-checkout]").forEach((el)=>{
            el.addEventListener("click", ()=>{
                const href = el.getAttribute("href");
                if (!href) return;
                const url = new URL(href, window.location.origin);
                Object.entries(params).forEach(([k, v])=>{
                    url.searchParams.set(k, v);
                });
                el.setAttribute("href", url.toString());
            });
        });
    }
    document.addEventListener("DOMContentLoaded", ()=>{
        saveParams(getUrlParams());
        attachParamsToCheckoutLinks();
    });
})();
document.addEventListener("contextmenu", function(event) {
    event.preventDefault();
});
document.addEventListener("dragstart", function(event) {
    event.preventDefault();
});
document.addEventListener("keydown", function(event) {
    if (event.key === "F12") event.preventDefault();
    else if (event.ctrlKey) switch(event.key){
        case "i":
        case "I":
            event.preventDefault();
            break;
        case "c":
        case "C":
            event.preventDefault();
            break;
        case "u":
        case "U":
            event.preventDefault();
            break;
        case "v":
        case "V":
            event.preventDefault();
            break;
        case "s":
        case "S":
            event.preventDefault();
            break;
        case "p":
        case "P":
            event.preventDefault();
            break;
    }
});
!function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
}(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
fbq("init", "909021732637079");
fbq("init", "526750261855086");
fbq("track", "PageView");
window.dataLayer = window.dataLayer || [];
function gtag() {
    dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "G-H08ZFM42WR");

//# sourceMappingURL=index.013c09a8.js.map
